module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "successCont",
    attrs: {
      "id": "success"
    }
  }, [_c('div', {
    staticClass: "success_main"
  }, [_c('div', {
    staticClass: "successBg"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("報名成功！")]), _vm._v(" "), _c('p', [_vm._v("感謝您的支持與信任，稍後谷町君會將會議詳細信息發送至您的手機上，請注意查收。")]), _vm._v(" "), _c('router-link', {
    staticClass: "apply_btn",
    attrs: {
      "tag": "div",
      "to": "/list"
    }
  }, [_vm._v("繼續報名")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f7b167","hasScoped":false}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Success.vue
// module id = 312
// module chunks = 1